import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

/**
 * C16-PREP T2-C: MiniSpinner inline para auth pages chicos (Register/Forgot/
 * ResetPassword) que usan `React.lazy()`. NO usa `min-h-screen` para evitar
 * flash full-screen entre rutas auth (LoginPage es eager — no triggers
 * Suspense).
 */
function MiniSpinner() {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="w-6 h-6 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export default function AuthLayout() {
  return (
    // Rediseño F4: fondo de marca — porcelana con tinte teal→tinta en vez del
    // blue-50 de Tailwind (uno de los "5 azules" del inventario).
    <div className="min-h-screen bg-gradient-to-b from-primary-50 via-gray-50 to-white dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 flex flex-col transition-colors">
      <main className="flex-1 flex flex-col items-center px-6 pt-6 pb-6">
        {/* Hero: logo + wallet combined in one image
            loading="eager" — above-the-fold critical asset (Login). */}
        <img
          src="/hero-login.webp"
          alt="SolidCycle"
          className="w-80 sm:w-96 h-auto object-contain"
          loading="eager"
        />

        {/* Form — Suspense distribution C16-PREP T2-C: cuando el router
            navega a un auth page lazy (Register/Forgot/Reset) este Suspense
            interno muestra MiniSpinner inline en vez de LoadingScreen
            full-screen del root Suspense en App.tsx (evita flash). */}
        <div className="w-full max-w-md">
          <Suspense fallback={<MiniSpinner />}>
            <Outlet />
          </Suspense>
        </div>
      </main>

      {/* Footer */}
      <footer className="pb-6 pt-2 text-center text-sm text-gray-400 dark:text-gray-500">
        Empieza hoy. Sin Excel. Sin estres.
      </footer>
    </div>
  );
}
